import ArticleStockRequest from "../transaction/ArticleStockRequest";

class AddArticleDeliveryStockRequest {
    public to: string;
    public comment?: string;
    public articles: ArticleStockRequest[];

    constructor(to: string, articles: ArticleStockRequest[], comment?: string) {
        this.to = to;
        this.comment = comment;
        this.articles = articles;
    }
}

export default AddArticleDeliveryStockRequest;